import React from "react";
import { Repeat, ShieldCheck, Target, Lock } from "lucide-react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { partner } = content;

const ICONS = { repeat: Repeat, shield: ShieldCheck, target: Target, lock: Lock };

export const Partner = () => (
  <Section id="zusammenarbeit" testId="section-partner" className="has-lines overflow-hidden">
    <FlowLines color="#0F9D6E" opacity={[0.035, 0.028]} />
    <Container>
      <Reveal>
        <Label>{partner.label}</Label>
        <AccentH2 className="mt-6 max-w-[760px] font-bold text-[#1e2532]">{partner.h2}</AccentH2>
        <p className="mt-6 max-w-[720px] text-[17px] leading-[1.8] text-[#565f70]">{partner.intro}</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-7">
        {partner.cards.map((c, i) => {
          const Icon = ICONS[c.icon] || Target;
          return (
            <Reveal key={c.h3} delay={(i % 2) * 0.1}>
              <article
                data-testid={`partner-card-${i}`}
                className="benefit-card group relative flex h-full flex-col overflow-hidden rounded-[16px] border border-[#dfe2e0] bg-white p-8 md:p-10"
              >
                <span className="benefit-card__bar" aria-hidden="true" />
                <span
                  className="pointer-events-none absolute right-7 top-6 font-display text-[64px] font-bold leading-none text-[#1e2532]/[0.05]"
                  aria-hidden="true"
                >
                  {String(i + 1).padStart(2, "0")}
                </span>

                <span className="flex h-12 w-12 items-center justify-center rounded-[10px] border border-[#0f9d6e]/25 bg-[#0f9d6e]/[0.07] text-[#0b7d57]">
                  <Icon size={22} strokeWidth={1.8} />
                </span>

                <h3 className="mt-6 font-semibold text-[#1e2532]">{c.h3}</h3>
                <p className="mt-4 text-[16.5px] leading-[1.76] text-[#565f70]">{c.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </Container>
  </Section>
);
